import gravatarUrl from "gravatar-url";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { userLoggedOut } from "../features/auth/authSlice";
import { search } from "../features/projects/projectSlice";

export default function Navbar() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth) || {};

  const logoutHandler = () => {
    dispatch(userLoggedOut());
    localStorage.clear();
  };

  const { pathname } = useLocation();

  const debounceHandler = (fn, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };

  const doSearch = (e) => {
    dispatch(search(e.target.value));
  };

  const handleSearch = debounceHandler(doSearch, 1000);
  return (
    <div className="flex items-center justify-between flex-shrink-0 w-full h-16 px-10 bg-white bg-opacity-75">
      <div className="flex items-center gap-10">
        <Link to="/">
          <img src={logo} className="h-8 w-8" alt="logo" />
        </Link>
        <div className="flex items-center">
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "mx-2 text-sm font-bold hover:bg-indigo-700 bg-indigo-700 text-white py-2 px-4 rounded-lg"
                : "mx-2 text-sm font-bold hover:bg-indigo-700 hover:text-white py-2 px-4 rounded-lg"
            }
            to="/projects"
          >
            Projects
          </NavLink>
          <NavLink
            to="/teams"
            className={({ isActive }) =>
              isActive
                ? "mx-2 text-sm hover:bg-indigo-700 bg-indigo-700 font-bold text-white py-2 px-4 rounded-lg"
                : "mx-2 text-sm hover:bg-indigo-700 hover:text-white font-bold py-2 px-4 rounded-lg"
            }
          >
            Team
          </NavLink>
          {pathname === "/projects" && (
            <input
              className="flex items-center h-10 px-4 ml-3 text-sm bg-gray-200 rounded-full focus:outline-none focus:ring"
              type="search"
              placeholder="Search for anything…"
              onChange={handleSearch}
            />
          )}
        </div>
      </div>
      <ul className="flex items-center gap-5 text-white">
        <li className="bg-rose-600 hover:bg-rose-700 px-2 py-1 text-center rounded">
          <span className="cursor-pointer text-sm" onClick={logoutHandler}>
            LOGOUT
          </span>
        </li>
        <li className="font-bold text-black">{user.name}</li>
        <li>
          <img
            className="object-cover w-10 h-10 rounded-full border-2 border-black"
            src={gravatarUrl(user.email, {
              size: 80,
            })}
            alt={user.name}
          />
        </li>
      </ul>
    </div>
  );
}
